
import { ButtonImg, Typography } from "components/ui";
import React from "react";
import { IconDeck, IconK, IconReset } from "shared/utils/assets";
import { ButtonImgStyle, CountDeckStyle, MainPanel } from "../styled";

const CardHeader = ({ deckLength, count, onReset }) => {
    return (
        <MainPanel style={{ flex: 1 }}>
            <ButtonImg src={IconReset} onClick={onReset} size={"3em"} />
            <CountDeckStyle>
                <Typography $size="3em" zIndex="1" $bolds>
                    {deckLength}
                </Typography>
                <ButtonImgStyle>
                    <ButtonImg size="4em" src={IconDeck} />
                </ButtonImgStyle>
            </CountDeckStyle>
            <CountDeckStyle>
                <Typography $size="3em" zIndex="1" $bolds>
                    {count}
                </Typography>
                <ButtonImgStyle>
                    <ButtonImg size="4em" src={IconK} />
                </ButtonImgStyle>
            </CountDeckStyle>
        </MainPanel>
    );
};

export default CardHeader;
